import React from 'react';
import { PropertiesPanelControl, PropertiesPanelIconButton, PropertiesPanelLabel, PropertiesPanelProperty } from './propertiesPanelProperty';

export type PropertiesPanelIconPropertyProps = {
    id: string;
    label: React.ReactNode;
    icon: React.ReactNode;
    onIconClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
};

// L'etichetta della riga è il nome del bottone: `htmlFor` punta al suo `id`.
export const PropertiesPanelIconProperty: React.FC<PropertiesPanelIconPropertyProps> = ({ id, label, icon, onIconClick, disabled }) => {
    return (
        <PropertiesPanelProperty>
            <PropertiesPanelLabel htmlFor={`${id}-input`}>{label}</PropertiesPanelLabel>
            <PropertiesPanelControl>
                <PropertiesPanelIconButton id={`${id}-input`} type='button' onClick={onIconClick} disabled={disabled}>
                    {icon}
                </PropertiesPanelIconButton>
            </PropertiesPanelControl>
        </PropertiesPanelProperty>
    );
};
